import React, {
	ChangeEvent,
	Dispatch,
	useCallback,
	useEffect,
	useState,
} from "react";
import { Select } from "@alm/flow-ds/components";
import { Actions, createFilter, setQueryFilter } from "./finderReducer";
import { operators, SelectElementDefinition } from "lib/api/types";
import { useTranslation } from "react-i18next";
import jsonpointer from "lib/jsonpointer/jsonpointer";

type Props = SelectElementDefinition & {
	index: number;
	dispatch: Dispatch<Actions>;
	queryValue?: string;
};

function SelectSearchField({
	index,
	id,
	label,
	options,
	dispatch,
	queryValue,
}: Props) {
	const { t } = useTranslation();
	const [value, setValue] = useState<undefined | string>(
		queryValue !== undefined ? queryValue : undefined
	);

	const onValueChange = useCallback(
		(event: ChangeEvent<HTMLSelectElement>) => {
			setValue(event.currentTarget.value);
		},
		[]
	);

	useEffect(() => {
		dispatch(
			setQueryFilter(
				createFilter(jsonpointer.pointerToId(id), operators.exact, {
					value,
				}),
				index,
				value || ""
			)
		);
	}, [dispatch, id, index, value]);

	return (
		<>
			<div className="col-6 col-md-2">
				<Select
					label={t("elements.finder.selectOperatorLabel")}
					value="exact"
					labelHidden={true}
					disabled>
					<option value="exact">{t("elements.finder.exact")}</option>
				</Select>
			</div>
			<div className="col-12 col-md-5 col-lg-6 col-xl-4 mt-3 mt-md-0">
				<Select
					label={t("elements.finder.searchInputLabel", {
						label,
					})}
					value={value}
					onChange={onValueChange}
					defaultValue="default"
					labelHidden={true}
					id={`qbf-input-${index}`}>
					<option value="default" disabled>
						{t("elements.finder.selectSearchFieldDefaultOption", {
							label,
						})}
					</option>
					{options.map((o, i) => (
						<option value={o} key={`${o}_${i}`}>
							{o}
						</option>
					))}
				</Select>
			</div>
		</>
	);
}

export default SelectSearchField;
